import React, { Component } from "react";
import { connect } from "react-redux";
import { Card, Col, PageHeader, Row } from "antd";
import { SegmentedItem } from "../../../Components/Items";
import SelectEmpleadosItem from "../../../Components/SelectEmpleadosItem";
import VacacionesEmpleado from "../PreNomina/VacacionesEmpleado/VacacionesEmpleado";
import VacacionesMasivas from "./VacacionesMasivas";

class Vacaciones extends Component {
  state = {
    modo: "empleado",
    empleadoId: null,
    empleadoNombre: "",
  };

  onChangeEmpleado = (value, option) => {
    this.setState({
      empleadoId: value || null,
      empleadoNombre: option?.children || "",
    });
  };

  render() {
    const { modo, empleadoId, empleadoNombre } = this.state;
    const { empresaId, headersToken } = this.props;

    return (
      <>
        <PageHeader
          title="Vacaciones"
          style={{
            border: "1px solid rgb(235, 237, 240)",
            backgroundColor: "white",
            marginBottom: 10,
          }}
          extra={
            <SegmentedItem
              options={[{ label: "Por empleado", value: "empleado" }, { label: "Masivo", value: "masivo" }]}
              value={modo}
              onChange={(value) => this.setState({ modo: value })}
            />
          }
        />

        {modo === "empleado" ? (
          <Row gutter={10}>
            <Col xs={24} md={8}>
              <Card
                title="Empleado"
                size="small"
                style={{ borderRadius: 6, boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}
              >
                <SelectEmpleadosItem
                  empresaId={empresaId}
                  headersToken={headersToken}
                  sinBorde
                  autoFocus
                  dropdownMatchSelectWidth={600}
                  value={empleadoId}
                  onChange={this.onChangeEmpleado}
                  allowClear
                  width="100%"
                  placeholder="Busca un empleado"
                />
                {!!empleadoNombre && (
                  <div style={{ marginTop: 6, fontSize: 12, color: "#999" }}>
                    Seleccionado: {empleadoNombre}
                  </div>
                )}
              </Card>
            </Col>

            <Col xs={24} md={16}>
              <Card
                title="Vacaciones del empleado"
                size="small"
                style={{ borderRadius: 6, boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}
              >
                {empleadoId ? (
                  <VacacionesEmpleado empleadoId={empleadoId} />
                ) : (
                  <div style={{ color: "#999", fontSize: 13, padding: "20px 0", textAlign: "center" }}>
                    Selecciona un empleado para ver y registrar sus vacaciones.
                  </div>
                )}
              </Card>
            </Col>
          </Row>
        ) : (
          <Card
            title="Vacaciones masivas"
            size="small"
            style={{ borderRadius: 6, boxShadow: "0 1px 2px rgba(0,0,0,0.05)" }}
          >
            <VacacionesMasivas />
          </Card>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => ({
  headersToken: state.user.headersToken,
  empresaId: state.empresa.id,
});

export default connect(mapStateToProps)(Vacaciones);
